import * as yup from 'yup';

export default yup.object().shape({
  name: yup.string().trim().max(256).required(),
  description: yup.string().trim().max(4096),
  properties: yup.object().required(),
});
